import {
    SHOP_DETAIL_KEY,
    ShopDetailTabs,
} from '../service/shop-details.interface';

export const tabs: ShopDetailTabs[] = [
    {
        label: 'Кастомизация',
        key: SHOP_DETAIL_KEY.CUSTOMIZATION,
    },
    {
        label: 'Стили',
        key: SHOP_DETAIL_KEY.STYLES,
    },
    {
        label: 'Аналитика',
        key: SHOP_DETAIL_KEY.ANALYTICS,
    },
    {
        label: 'Документы',
        key: SHOP_DETAIL_KEY.DOCUMENTS,
    },
];
